import React, { useState } from 'react';
import { Flex, Text } from '@mantine/core';
import CustomCalendarButtons from './CustomCalendarButtons';
import Toastr from 'components/Toastr';

interface MeetingDetails {
  name: string;
  startDate: string;     // YYYY-MM-DD
  startTime: string;     // HH:mm (24h format)
  endTime: string;       // HH:mm (24h format)
  location?: string;
  description?: string;
  timeZone?: string;
}

interface CalendarConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
  meetingDetails?: MeetingDetails;
}

const CalendarConfirmationModal: React.FC<CalendarConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onClose,
  meetingDetails
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [showToastr, setShowToastr] = useState(false);
  const [toastrMessage, setToastrMessage] = useState('');

  if (!isOpen) return null;

  const handleCalendarAdded = async (providerName: string) => {
    // Show toast notification
    setToastrMessage(`Added to ${providerName}`);
    setShowToastr(true);

    // Save to backend
    await onConfirm();

    // Auto-dismiss modal after 1.5 seconds
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 1500);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '420px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        <Flex gap={20} direction="column" align="center">
          <Text size="18px" fw={600} style={{ textAlign: 'center', color: '#111827' }}>
            Add to Calendar
          </Text>

          <Text size="14px" fw={400} style={{ textAlign: 'center', color: '#6B7280', marginTop: '-8px' }}>
            Select your preferred calendar to add this follow-up meeting
          </Text>

          {meetingDetails && (
            <CustomCalendarButtons
              meetingDetails={meetingDetails}
              onCalendarAdded={handleCalendarAdded}
            />
          )}
        </Flex>
      </div>
      <Toastr
        message={toastrMessage}
        isVisible={showToastr}
        onClose={() => setShowToastr(false)}
      />
    </div>
  );
};

export default CalendarConfirmationModal;
